/**
 * Hero Section Black Friday - JavaScript
 * Gère les interactions et animations du hero
 */

(function() {
  'use strict';

  // Configuration par défaut
  const CONFIG = {
    totalProducts: 1000,
    totalBrands: 50,
  };

  /**
   * Initialise le hero section
   */
  function initHero() {
    const heroSection = document.querySelector('.hero-section--blackfriday');
    if (!heroSection) return;

    // Mettre à jour les stats dynamiques
    updateStats();

    // Ajouter les animations d'entrée
    animateOnLoad();
  }

  /**
   * Met à jour les statistiques affichées
   */
  function updateStats() {
    // Récupérer les valeurs depuis les data attributes ou utiliser les valeurs par défaut
    const heroSection = document.querySelector('.hero-section--blackfriday');
    if (!heroSection) return;

    const totalProducts = heroSection.dataset.totalProducts || CONFIG.totalProducts;
    const totalBrands = heroSection.dataset.totalBrands || CONFIG.totalBrands;

    // Mettre à jour les valeurs dans le DOM
    const productsValue = heroSection.querySelector('.hero-section__stat[data-stat="products"] .hero-section__stat-value');
    const brandsValue = heroSection.querySelector('.hero-section__stat[data-stat="brands"] .hero-section__stat-value');

    if (productsValue) {
      productsValue.textContent = formatNumber(totalProducts) + '+';
    }

    if (brandsValue) {
      brandsValue.textContent = formatNumber(totalBrands) + '+';
    }
  }

  /**
   * Formate un nombre avec des séparateurs de milliers
   */
  function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * Ajoute des animations d'entrée au chargement
   */
  function animateOnLoad() {
    const heroSection = document.querySelector('.hero-section--blackfriday');
    if (!heroSection) return;
    
    const elements = heroSection.querySelectorAll('.hero-section__badge-inner, .hero-section__title, .hero-section__subtitle, .hero-section__description, .hero-section__cta, .hero-section__stats');
    
    elements.forEach((el, index) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
      
      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, index * 100);
    });
  }

  /**
   * Gère le hover sur les boutons
   */
  function initButtonHovers() {
    const heroSection = document.querySelector('.hero-section--blackfriday');
    if (!heroSection) return;
    
    const buttons = heroSection.querySelectorAll('.hero-section__button');
    
    buttons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        if (this.classList.contains('hero-section__button--primary')) {
          this.style.transform = 'scale(1.05)';
        }
      });
      
      button.addEventListener('mouseleave', function() {
        if (!this.classList.contains('hero-section__button--primary')) {
          this.style.transform = 'scale(1)';
        }
      });
    });
  }

  /**
   * Gère le hover sur les stats
   */
  function initStatsHovers() {
    const heroSection = document.querySelector('.hero-section--blackfriday');
    if (!heroSection) return;
    
    const stats = heroSection.querySelectorAll('.hero-section__stat');
    
    stats.forEach(stat => {
      stat.addEventListener('mouseenter', function() {
        const iconWrapper = this.querySelector('.hero-section__stat-icon-wrapper');
        if (iconWrapper) {
          iconWrapper.style.transform = 'scale(1.1)';
        }
      });
      
      stat.addEventListener('mouseleave', function() {
        const iconWrapper = this.querySelector('.hero-section__stat-icon-wrapper');
        if (iconWrapper) {
          iconWrapper.style.transform = 'scale(1)';
        }
      });
    });
  }

  // Initialisation au chargement du DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHero();
      initButtonHovers();
      initStatsHovers();
    });
  } else {
    initHero();
    initButtonHovers();
    initStatsHovers();
  }

  // Exposer les fonctions pour utilisation externe si nécessaire
  window.HeroSection = {
    updateStats: updateStats,
    init: initHero
  };

})();

